module.exports = __webpack_public_path__ + "static/media/flag-alt.a02579d7.svg";